var image_viewer_rtlignore_default = {
  "fontElementMap": "TPSll",
  "imageContainer": "D2CyP",
  "expandButton": "-rcYH",
  "expandIcon": "_2fNf8",
  "pointer": "u-Sq9",
  "imageWrapper": "_9w4UZ",
  "imageRatio": "_9fMjY",
  "image": "cgsBS",
  "imageOverlay": "h1uQc",
  "imagePreload": "o3mxm",
  "imageHighres": "-qnMM",
  "onlyHighRes": "_5oaz1",
  "image_loading": "atrrU"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
